import { record, Replayer } from "rrweb";
// import { sendSensorTrack } from "@/utils/sensor";

import axios from "axios";
const prd = location.hostname.indexOf("pingan") > -1;

export class Record {
  constructor(uploadParams = {}, option = {}) {
    const { sessionId = "", sysId } = uploadParams;
    const {
      timeout = 30,
      autoSave = true,
      saveInterval = 5,
      replayZone
    } = option;
    this.saveInterval = saveInterval; //上传服务器的时间间隔（默认10秒上传一次）
    this.events = []; //存放录制的数据
    this.uploadEvents = []; // 要上传的数据
    this.maxEvents = 50; //最大事件数，如果达到这个数据立马上传（如果有正在上传的会先终止请求）
    this.outEvents = 350;
    this.stopRecordFn = null; //停止录制方法
    this.uploadTimer = null; //上传定时器
    // 上传 消息体
    this.uploadParams = uploadParams;
    //录制session（时间戳转36进制+随机数转36进制）
    this.recordSession = sessionId || `${sysId}-${this.randomStr()}`;
    this.uploading = false;
    this.CancelToken = axios.CancelToken;
    //取消上传请求方法
    this.cancelAxios = null;
    this.force = false;
    this.auto = autoSave;
    this.timeout = timeout;

    // 回访区域ID
    this.replayZone = replayZone;
    // 错误次数
    this.maxErrors = 0;
  }
  //开始录制
  start() {
    console.log("开始录制~~~~~~~~", this.recordSession);
    const that = this;
    this.stopRecordFn = record({
      emit(event) {
        that.events.push(event);
        // console.log("that.events.length >>", that.events.length);
      }
    });
    //定时自动保存录制数据传递到后台
    this.auto && this.autoSave();
  }

  //停止录制
  stop(cb) {
    console.log("停止录制~~~~~~~~");
    this.stopRecordFn && this.stopRecordFn();
    this.uploadTimer && clearInterval(this.uploadTimer);
    typeof cb === "function" && cb();
  }

  //自动定时上传数据
  autoSave() {
    this.uploadTimer && clearInterval(this.uploadTimer);
    this.uploadTimer = setInterval(() => {
      console.log(`超过${this.saveInterval}秒，自动上传数据！`);
      console.log(" 自动上传 this.uploadEvents", this.uploadEvents.length);
      console.log(" 自动上传 this.events", this.events.length);
      // 每次上传前50个 event + 上传失败的 event,使用splice()方法，改变原数组uploadEvents，否则uploadEvents 指数增长
      this.uploadEvents = [
        ...this.uploadEvents.splice(0),
        ...this.events.splice(0, 50)
      ];
      console.log(">>> 上传 this.uploadEvents", this.uploadEvents.length);
      if (
        this.events.length > this.outEvents ||
        this.uploadEvents.length > this.outEvents
      ) {
        console.log(`>>>> 大于 ${this.outEvents} 清空 events列表,停止上传`);
        this.clearAndStop();
      }
      this.upload(
        () => {
          console.log(":)上传数据成功！");
        },
        () => {
          console.log("):上传数据失败！");
        }
      );
    }, this.saveInterval * 1000);
  }
  //立即上传数据
  save(ok, fail) {
    console.log(`立即上传！`);
    this.cancelAxios && this.cancelAxios();
    this.uploading = false;
    // 全部上传
    console.log(" 全部上传 this.uploadEvents", this.uploadEvents.length);
    console.log(" 全部上传 this.events", this.events.length);
    this.uploadEvents = [
      ...this.uploadEvents.splice(0),
      ...this.events.splice(0)
    ];
    console.log(" 立即 全部上传 this.uploadEvents<<<<<", this.uploadEvents);
    if (
      this.events.length > this.outEvents ||
      this.uploadEvents.length > this.outEvents
    ) {
      console.log(`>>>> 大于 ${this.outEvents} 清空 events列表,停止上传`);
      this.clearAndStop();
    }
    this.upload(ok, fail);
  }

  // 清空 事件列表  停止录像
  clearAndStop() {
    console.log("clear And Stop>>>");
    this.events = [];
    this.uploadEvents = [];
    this.uploadTimer && clearInterval(this.uploadTimer);
    this.stop();
  }
  //获取录制的数据
  getEvents() {
    return this.events;
  }

  //获取录制的sessionid
  getRecordSession() {
    return this.recordSession;
  }

  // 设置 保单号
  setPolicyNo(policyNo, ok, fail) {
    this.uploadParams.policyNo = policyNo;
    this.save(ok, fail);
  }
  // 设置交易号
  setTransNo(transNo) {
    this.uploadParams.transNo = transNo;
    // this.save(ok, fail);
  }

  /**
   * 随机生成由字母和数字组成的字符串
   * @param len    需要生成的字符串长度（默认16位）
   * @returns {*}
   */
  randomStr(len = 16) {
    const randStr = () =>
      Math.random()
        .toString(36)
        .slice(2);
    const assignLenStr = (str, len) => {
      if (str.length >= len) {
        return str.slice(0, len);
      }
      return assignLenStr(str + randStr(), len);
    };
    return assignLenStr(randStr(), len);
  }

  /**
   *
   * sessionId 必传
   * transNo 否
   * pageId 必传
   * timeStamp 必传
   * sysId 必传
   * version 必传
   * insuranceFlag 必传
   * 投保流程校验规则上报
   *
   */
  addInsuranceCheckRule(recordflag) {
    console.log("投保流程校验规则上报开关状态是=====>", recordflag);
    if (recordflag) {
      console.log("addInsuranceCheckRule 投保流程校验规则上报开始~~~~");
      const origin = prd
        ? "https://osr.pingan.com"
        : "https://osr-test.paic.com.cn";

      const api = `${origin}/online-storage/addInsuranceCheckRule`;

      const {
        policyNo = "",
        transNo = "",
        applyPolicyNo = "",
        sysId = "pa18-shop-nst", // 系统ID
        pageId = "", // 页面ID（必传）
        version = "", // 版本号（必传）
        dataFlag = "0",
        insuranceFlag = "1" // "0"车险"1"非车"2"团
      } = this.uploadParams;
      const param = {
        timeStamp: (+new Date()).toString(), // 时间戳
        sessionId: this.recordSession, // 录制ID
        policyNo,
        transNo,
        applyPolicyNo,
        sysId,
        pageId,
        version,
        dataFlag,
        insuranceFlag
      };
      let params = {
        context: "",
        timeStamp: param.timeStamp,
        transNo: param.transNo,
        sessionId: param.sessionId
      };
      axios({
        method: "post",
        url: api,
        data: param,
        timeout: this.saveInterval * 1000 * 2,
        headers: { "Content-Type": "application/json" }
      })
        .then((res = {}) => {
          const { data: response = {} } = res || {};
          const { code, msg } = response;
          if (code === 0) {
            console.log("可回溯质检上报成功", param.pageId);
          } else {
            console.warn("可回溯质检上报失败 218", response);

            try {
              // 添加错误埋点
              // 借用热线code存储错误节点信息 NST_H010008
              let compassAttributes = {
                event: "NST_H010008",
                click_time: new Date().getTime(),
                main_insurance_name: "Init_error_msg",
                compare_insurance_name: "addInsuranceCheckRule",
                search_key_word: "可回溯质检上报失败"
              };
              console.log(
                "rrweb addInsuranceCheckRule ===>",
                compassAttributes
              );
              // sendSensorTrack(compassAttributes);
              params.context = msg;
              this.nstReport(params);
            } catch (e) {
              console.log("record info error", e);
            }
          }
        })
        .catch((err = {}) => {
          console.log("可回溯质检上报失败 222", err);

          try {
            // 添加错误埋点
            // 借用热线code存储错误节点信息 NST_H010008
            let compassAttributes = {
              event: "NST_H010008",
              click_time: new Date().getTime(),
              main_insurance_name: "Init_error_msg",
              compare_insurance_name: "addInsuranceCheckRule",
              search_key_word: "可回溯质检上报失败"
            };
            console.log(
              "rrweb addInsuranceCheckRule error ===>",
              compassAttributes
            );
            // sendSensorTrack(compassAttributes);
            params.context = err.message;
            this.nstReport(params);
          } catch (e) {
            console.log("record info error", e);
          }
        });
    }
  }

  //上传录制数据
  upload(ok, fail) {
    if (this.uploading || this.uploadEvents.length == 0) {
      console.log(">>> 上传等待 中 >>>>>>...");

      return;
    }
    console.log("上传数据中~~~~");

    const origin = prd
      ? "https://osr.pingan.com"
      : "https://osr-test.paic.com.cn";
    const api = `${origin}/online-storage/record`;
    const {
      policyNo = "",
      transNo = "",
      applyPolicyNo = "",
      sysId = "pa18-shop-nst",
      pageId = "",
      version = "",
      dataFlag = "0",
      insuranceFlag = "1"
    } = this.uploadParams;
    const events = JSON.stringify(this.uploadEvents);
    console.log(
      `——————————>>>>>>>>>>上传时 uploadEvents 长度：${this.uploadEvents.length}, 字符串长度： ${events.length}`
    );
    const uploadEventsLen = this.uploadEvents.length;
    const param = {
      htmlData: events,
      timeStamp: +new Date(),
      sessionId: this.recordSession,
      policyNo,
      transNo,
      applyPolicyNo,
      sysId,
      pageId,
      version,
      dataFlag,
      insuranceFlag
    };
    let params = {
      context: "",
      timeStamp: param.timeStamp,
      transNo: param.transNo,
      sessionId: param.sessionId
    };
    this.uploading = true;
    axios({
      method: "post",
      url: api,
      data: param,
      timeout: this.timeout * 1000,
      headers: { "Content-Type": "application/json" },
      cancelToken: new this.CancelToken(c => {
        this.cancelAxios = c;
      })
    })
      .then((res = {}) => {
        const { data: response = {} } = res || {};
        const { code, msg = "接口异常~" } = response;
        if (code === 0) {
          //每次上传成功清空 上传数据
          this.uploadEvents.splice(0, uploadEventsLen);
          console.log(
            `——————————>>>>>>>>>>上传成功清空uploadEvents后 长度：${this.uploadEvents.length}, events 长度：${this.events.length}`
          );
          this.uploading = false;
          typeof ok === "function" && ok(msg);
        } else {
          params.context = msg;
          this.nstReport(params);
          typeof fail === "function" && fail();
        }
      })
      .catch((err = {}) => {
        this.maxErrors++;
        console.log(">>> catch 失败>>>>, 次数", this.maxErrors);
        this.uploading = false;
        typeof fail === "function" && fail(err);
        if (this.maxErrors > 5) {
          this.maxErrors = 0;
          this.stop();
        }
        params.context = err.message;
        this.nstReport(params);
      })
      .finally(() => {
        // this.uploading = false;
      });
    this.nstRecord(param);
  }

  // 回访
  replay(events, replayZone = this.replayZone, speed = 1) {
    events.length > 0 &&
      new Replayer(events, {
        root: document.getElementById(replayZone),
        data: {
          autoPlay: true
        },
        speed
      }).play();
  }
  // 第一版仅对P020078生效
  nstRecord(param) {
    try {
      let params = {
        context: "",
        timeStamp: param.timeStamp,
        transNo: param.transNo,
        sessionId: param.sessionId
      };
      if (param.pageId && param.pageId === "/P020078") {
        const origin = prd
          ? "https://baoxian.pingan.com"
          : "https://dmzstg1.pa18.com";
        const api = `${origin}/pa18shopnst/do/storage/nstrecord`;
        axios({
          method: "POST",
          url: api,
          data: param,
          timeout: this.timeout * 1000,
          headers: { "Content-Type": "application/json" }
        })
          .then(res => {
            if (res.data.resultCode !== "0") {
              params.context = res.data.resultMsg;
              this.nstReport(params);
            }
          })
          .catch(err => {
            params.context = err.message;
            this.nstReport(params);
          });
      }
    } catch (err) {
      console.log("nstRecord err:::", err);
    }
  }
  nstReport(param) {
    try {
      const origin = prd
        ? "https://baoxian.pingan.com"
        : "https://dmzstg1.pa18.com";
      const api = `${origin}/pa18shopnst/do/storage/nstreport`;
      axios({
        method: "GET",
        url: api,
        params: param,
        timeout: this.timeout * 1000,
        headers: { "Content-Type": "application/json" }
      }).then(res => {
        console.log("事件上报::", res);
      });
    } catch (err) {
      console.log("nstReport err:::", err);
    }
  }
}
// 获取数据
export function GetReplayData(params = {}, successCb, failCb) {
  const {
    tranNo = "",
    policyNo = "",
    insuranceFlag = "1",
    timeout = 20 * 1000 //接口超时时间（毫秒）
  } = params;
  const origin = prd
    ? "http://hcz-docker.sze-sf-caas.paic.com.cn"
    : "http://hcz-docker-test.shb-sf-caas.paic.com.cn";
  const policyAPI = `${origin}/online-recall/backtrackingFile/queryVideoByPolicyNo`;
  //交易号查询接口
  const tranNoAPI = `${origin}/online-recall/recallFile/queryVideoByTranNo`;

  const api = policyNo ? policyAPI : tranNoAPI;
  const param = policyNo
    ? { policyNo, insuranceFlag }
    : { tranNo, insuranceFlag };
  const XHROption = {
    method: "get",
    url: api,
    params: param,
    headers: { "Content-Type": "application/json" }
  };
  timeout && Object.assign(XHROption, { timeout });
  axios(XHROption)
    .then((res = {}) => {
      const { data: response = {} } = res || {};
      const { data: events = [], code, message = "接口异常~" } = response;
      if (code === 0) {
        //过滤出回放数据
        const replayData = events.filter((v = {}) => {
          //dataFlag为"0"表示回放数据 "1"是截图
          const { dataFlag = "", iobsData = "" } = v;
          return iobsData && dataFlag === "0";
        });
        //把回放片段整合一起播放
        const eventData = replayData.reduce((acc, v2 = {}) => {
          const { iobsData = "" } = v2;
          const event = JSON.parse(iobsData);
          console.log("整合 event >>", event);

          acc.push(...event);
          return acc;
        }, []);
        //只取最后一条回放数据
        const eventData2 = JSON.parse(
          replayData[replayData.length - 1].iobsData
        );
        console.log("eventData===", eventData);
        console.log("eventData2===", eventData2);
        typeof successCb === "function" && successCb(eventData);
      } else {
        typeof failCb === "function" && failCb();
        console.log("获取回放数据接口失败：", message);
      }
    })
    .catch(err => {
      typeof failCb === "function" && failCb();
      console.log("获取回放数据接口发生错误：", err);
    });
}
// 	上报保单关联关系数据
export function AddAssociation(params = {}, successCb, failCb) {
  const {
    policyNo = "",
    applyPolicyNo = "",
    sessionId = "",
    transNo = "",
    timeStamp = +new Date(),
    sysId = "pa18-shop-nst",
    insuranceFlag = "1",
    sceneFlag = 0 // 0:出单；1：批改 2：自助卡激活 4：财务
  } = params;
  const param = {
    policyNo,
    applyPolicyNo,
    sessionId,
    transNo,
    timeStamp,
    sysId,
    insuranceFlag,
    sceneFlag
  };
  const origin = prd
    ? "https://osr.pingan.com"
    : "https://osr-test.paic.com.cn";
  const api = `${origin}/online-storage/addAssociation`;
  axios({
    method: "post",
    url: api,
    data: param,
    headers: { "Content-Type": "application/json" }
  })
    .then((res = {}) => {
      const { data: response = {} } = res || {};
      const { data = {}, message = "接口异常~" } = response;
      typeof successCb === "function" && successCb(data);
      console.log("上报保单关联关系数据 成功： ", message);
    })
    .catch(err => {
      typeof failCb === "function" && failCb();
      console.log("2.	上报保单关联关系数据发生错误：", err);
      let params = {
        context: err.message,
        timeStamp: param.timeStamp,
        transNo: param.transNo,
        sessionId: param.sessionId
      };
      this.nstReport(params);
    });
}

// 	上报保单关联关系数据
export function nstAddAssociation(params = {}, successCb, failCb) {
  const {
    policyNo = "",
    applyPolicyNo = "",
    sessionId = "",
    transNo = ""
  } = params;
  const param = {
    policyNo,
    applyPolicyNo,
    sessionId,
    transNo
  };

  let originPa18BaseUrl = location.origin;
  if (!originPa18BaseUrl) {
    originPa18BaseUrl = location.protocol + "//" + location.host;
  }
  const apiPa18 = `${originPa18BaseUrl}/pa18shopnst/do/era/core/base/addAssociation`;

  axios({
    method: "post",
    url: apiPa18,
    data: param,
    headers: { "Content-Type": "application/json" }
  })
    .then((res = {}) => {
      const { data: response = {} } = res || {};
      const { data = {}, message = "接口异常~" } = response;
      typeof successCb === "function" && successCb(data);
      console.log("上报pa18-shop-nst保单关联关系数据 成功： ", message);
    })
    .catch(err => {
      typeof failCb === "function" && failCb();
      console.log("2.	上报pa18-shop-nst保单关联关系数据发生错误：", err);
    });
}
